import { Link } from 'react-router-dom';

const LOGO = 'https://alldoneroofing1.com/wp-content/uploads/2025/05/WhatsApp_Image_2025-06-09_at_22.16.18_f08d1b10-removebg-preview-1-e1749507470340.png';

export default function Footer() {
  return (
    <footer className="bg-obsidian text-white relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 md:pt-20 pb-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">

          {/* Brand */}
          <div className="lg:col-span-4">
            <div className="mb-6">
              <img src={LOGO} alt="All Done Roofing LLC" className="h-16 w-auto object-contain" />
            </div>
            <p className="text-white/45 text-sm leading-relaxed font-light max-w-xs">
              Mississippi Gulf Coast&apos;s premier roofing contractor. GAF Certified and Fortification Certified professionals delivering durable roofing systems built for coastal conditions.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="https://www.facebook.com/alldoneroofing/" target="_blank" rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/15 text-white/50 hover:border-gold/50 hover:text-gold transition-all rounded cursor-pointer">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="mailto:alldoneroofing1@gmail.com"
                className="w-9 h-9 flex items-center justify-center border border-white/15 text-white/50 hover:border-gold/50 hover:text-gold transition-all rounded cursor-pointer">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
            <div className="flex flex-wrap gap-2 mt-6">
              {['GAF Certified', 'Fortification Certified', 'Licensed & Insured'].map(cert => (
                <span key={cert} className="text-[10px] font-bold tracking-widest uppercase text-white/30 border border-white/10 px-3 py-1.5 rounded-full">
                  {cert}
                </span>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div className="lg:col-span-2">
            <h4 className="text-[10px] font-bold tracking-super uppercase text-gold mb-6">Navigation</h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Home', to: '/' },
                { label: 'About Us', to: '/about' },
                { label: 'Roof Replacement', to: '/services/roof-replacement' },
                { label: 'Storm Damage', to: '/services/storm-damage-restoration' },
                { label: 'Insurance Claims', to: '/services/insurance-claim-assistance' },
              ].map(item => (
                <li key={item.label}>
                  <Link to={item.to}
                    className="text-[12px] text-white/40 hover:text-gold transition-colors cursor-pointer tracking-wider uppercase flex items-center gap-2">
                    <span className="w-3 h-px bg-gold/40 inline-block"></span>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="lg:col-span-3">
            <h4 className="text-[10px] font-bold tracking-super uppercase text-gold mb-6">Services</h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Roof Replacement', to: '/services/roof-replacement' },
                { label: 'Roof Repairs', to: '/services/roof-repairs' },
                { label: 'Storm Damage Restoration', to: '/services/storm-damage-restoration' },
                { label: 'Insurance Claim Help', to: '/services/insurance-claim-assistance' },
                { label: 'Commercial Roofing', to: '/services/commercial-roofing' },
              ].map(s => (
                <li key={s.label}>
                  <Link to={s.to}
                    className="text-[12px] text-white/40 hover:text-gold transition-colors cursor-pointer tracking-wider uppercase flex items-center gap-2">
                    <span className="w-3 h-px bg-gold/40 inline-block"></span>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h4 className="text-[10px] font-bold tracking-super uppercase text-gold mb-4 mt-7">Service Areas</h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: 'Gulfport, MS', to: '/locations/gulfport-ms' },
                { label: 'Biloxi, MS', to: '/locations/biloxi-ms' },
                { label: 'Ocean Springs, MS', to: '/locations/ocean-springs-ms' },
                { label: 'Long Beach, MS', to: '/locations/long-beach-ms' },
                { label: 'Bay St. Louis, MS', to: '/locations/bay-st-louis-ms' },
              ].map(a => (
                <li key={a.label}>
                  <Link to={a.to}
                    className="text-[11px] text-white/35 hover:text-gold transition-colors cursor-pointer tracking-wider uppercase flex items-center gap-2">
                    <i className="ri-map-pin-2-line text-gold/60 text-[10px] shrink-0"></i>
                    {a.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-3">
            <h4 className="text-[10px] font-bold tracking-super uppercase text-gold mb-6">Contact Us</h4>
            <div className="flex flex-col gap-5">
              <div>
                <p className="text-[10px] tracking-widest uppercase text-white/25 mb-1">Phone</p>
                <a href="tel:2285473887" className="text-white/70 hover:text-gold transition-colors text-sm font-medium cursor-pointer">
                  (228) 547-3887
                </a>
              </div>
              <div>
                <p className="text-[10px] tracking-widest uppercase text-white/25 mb-1">Email</p>
                <a href="mailto:alldoneroofing1@gmail.com" className="text-white/70 hover:text-gold transition-colors text-sm font-medium cursor-pointer">
                  alldoneroofing1@gmail.com
                </a>
              </div>
              <div>
                <p className="text-[10px] tracking-widest uppercase text-white/25 mb-1">Service Area</p>
                <p className="text-white/70 text-sm leading-relaxed">
                  Mississippi Gulf Coast<br />
                  Gulfport, MS &amp; Surrounding Areas
                </p>
              </div>
              <Link to="/about"
                className="inline-flex items-center gap-2 bg-gold text-ink font-bold text-[11px] tracking-widest uppercase px-5 py-3 rounded hover:bg-gold-light transition-colors cursor-pointer whitespace-nowrap w-fit">
                <i className="ri-calendar-check-line text-sm"></i>
                Free Estimate
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-white/25 tracking-wider">&copy; 2026 All Done Roofing LLC. All Rights Reserved.</p>
          <p className="text-[11px] text-white/25 tracking-wider">Licensed &amp; Insured | GAF Certified | Fortification Certified | Mississippi</p>
        </div>
      </div>
    </footer>
  );
}
